import { Filters } from "./filters";
import { Summary } from "./summary";
import { Columns } from "./columns";
import { BulkActions } from "./bulk-actions";
import { ReportConfigBase } from "../index";
import { EReportTypes } from "../../routes/report_types";

const FinanceExportedBillsReportConfig: ReportConfigBase = {
  type: EReportTypes.FinanceExportedBills,
  endpoint: "bill/exported-bills",
  filtersBase: Filters,
  summaryBase: Summary,
  columnsBase: Columns,
  withSelection: true,
  intro: {
    description:
      "Exported Bills",
    url: "https://help.commonsku.com/knowledge/new-billing-reports"
  },
  bulkActions: BulkActions,
};

export default FinanceExportedBillsReportConfig;
